'use strict';

import $ from 'jquery';
import utilities from '../../js/utilities';
import * as globalisation from '../../utilities/globalisation';
import FormView from '../Form/FormView';
import ModalView from '../../js/components/ModalView';
import modalTemplate   from './templates/_ContactFormModalMessage.hbs';
import failedTemplate  from './templates/_ContactFormModalFail.hbs';
import successTemplate from './templates/_ContactFormModalSuccess.hbs';
import loaderTemplate  from '../../tmpl/client/loader.hbs';

let instance = null;

export default class ContactFormModal extends ModalView {
  get events() {
    return {
      'click .u-form-submit': 'submitForm'
    };
  }

  initialize() {
    super.initialize({ template: modalTemplate });
  }

  initializeElements() {
    this.$header = this.$('.Modal-header');
    this.$content = this.$('.Modal-inner');
    this.$form = this.$('.u-form');
  }

  initializeForm() {
    this.form = new FormView({
      el: this.$('.u-form')
    });
  }

  open(data) {
    super.open(data);
    this.initializeElements();
    this.initializeForm();
  }

  loading() {
    this.$header.text(globalisation.pluraliseAndTranslate('contactModal', 'messageTitleSending'));
    this.$content.html(loaderTemplate());
  }

  submitForm() {
    this.form.validateForm();

    if (this.form.validator.numberOfInvalids()) {
      return false;
    }

    let data = this.form.serializeToJson();
    let promise = $.ajax(this.modalData.endPoint, {
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      method: 'post',
      data: utilities.addCustIpToDataObject(data),
      beforeSend: this.loading.bind(this)
    });

    promise.done(this.onSubmitSuccess.bind(this));
    promise.fail(this.onSubmitFailed.bind(this));

    return false;
  }

  onSubmitSuccess() {
    this.$header.text(globalisation.pluraliseAndTranslate('contactModal', 'messageTitleSuccess'));
    this.$content.html(successTemplate()); // TODO to be decided what happens
  }

  onSubmitFailed(response) {
    this.$header.text(response.Error);
    this.$content.html(failedTemplate()); // TODO error design? What happens on error?
  }

  /**
   * Get the singleton instance of the ContactFormModal.
   *
   * @returns {ContactFormModal}
   */
  static getInstance() {
    if (!instance) {
      instance = new ContactFormModal();
    }

    return instance;
  }
}



// WEBPACK FOOTER //
// ./assets/components/ContactFormModal/ContactFormModal.js